import "../../assets/index9.css";
import { jsxs as a, jsx as t } from "react/jsx-runtime";
import { I as l } from "../../chunks/index.3a885b6a.js";
import { m as N } from "../../chunks/make-refs.cb0b9b76.js";
import { c as w } from "../../chunks/index.80e735c1.js";
import { forwardRef as I, useState as $ } from "react";
const k = "_notification_1il3j_1", H = "_dismiss_1il3j_17", R = "_container_1il3j_24", T = "_text_1il3j_30", D = "_heading_1il3j_39", M = "_hidden_1il3j_68", S = "_success_1il3j_72", q = "_warning_1il3j_79", z = "_error_1il3j_86", i = {
  notification: k,
  dismiss: H,
  container: R,
  text: T,
  heading: D,
  hidden: M,
  success: S,
  warning: q,
  error: z
}, L = I(
  ({
    a11yDismissLabel: m,
    a11yDismissTitle: d,
    children: e,
    className: _,
    hasDismissButton: f = !0,
    heading: c,
    onClose: n,
    variant: s = "info",
    ...u
  }, p) => {
    const { $el: g, $dismiss: h } = N(p, ["$el", "$dismiss"]), r = {
      info: "24/symbol/information",
      success: "24/symbol/status-success",
      warning: "24/symbol/status-alert",
      error: "24/symbol/status-error"
    }, j = r[s] || r.info, [o, y] = $(!1), b = () => {
      y(!o), n == null || n();
    }, x = w(i.notification, _, {
      [i[s]]: s !== "info",
      [i.hidden]: o
    });
    return /* @__PURE__ */ a(
      "div",
      {
        role: s === "error" || s === "warning" ? "alert" : "note",
        ref: g,
        className: x,
        "aria-hidden": o,
        ...u,
        children: [
          /* @__PURE__ */ t(l, { icon: j }),
          /* @__PURE__ */ a("div", { className: i.container, children: [
            c && /* @__PURE__ */ t("strong", { className: i.heading, children: c }),
            e ? /* @__PURE__ */ t("p", { className: i.text, children: e }) : null
          ] }),
          f && /* @__PURE__ */ t(
            "button",
            {
              "aria-label": m,
              className: i.dismiss,
              onClick: b,
              ref: h,
              title: d,
              type: "button",
              children: /* @__PURE__ */ t(l, { icon: "24/symbol/x" })
            }
          )
        ]
      }
    );
  }
);
export {
  L as Notification
};
//# sourceMappingURL=index.js.map
